export default "__VITE_ASSET__BP7H98Fe__"